import React, { useMemo } from 'react';
import { Button, ScreenContainer, ContentFrame } from '@pinwheel/origami';
import useSuccess from '../hooks/useSuccess';
import { TemplateContinue } from '../components/TemplateContinue';
import { useOpts } from '../context';
import useTerminalScreenButtonText from '../hooks/useTerminalScreenButtonText';
import SuccessAnimation from '../components/SuccessAnimation';
import ReopenPinwheelButton, { useShouldShowReopenPinwheelButton, } from '../components/ReopenPinwheelButton';
import useLinkSolution from '../hooks/useLinkSolution';
import { useGetLocalizedString } from '../hooks/useGetLocalizedString';
import useLinkNavigate from '../hooks/useLinkNavigate';
/**
 * This component is used to show the success screen. It looks to SuccessContext
 * for its text strings.
 */
var Success = function () {
    var navigate = useLinkNavigate();
    var exit = useOpts().exit;
    var _a = useSuccess(), title = _a.title, subtitle = _a.subtitle;
    var shouldShowReopenButton = useShouldShowReopenPinwheelButton();
    var buttonLabel = useTerminalScreenButtonText();
    var linkSolution = useLinkSolution().linkSolution;
    var getLocalizedString = useGetLocalizedString();
    var actions = useMemo(function () {
        var isSwitchKit = linkSolution && linkSolution === 'Switch Kit';
        return (React.createElement(React.Fragment, null,
            isSwitchKit ? (React.createElement(Button, { eventId: "SwitchKit-proceed-to-homer", dataTestId: "homer-button", onClick: function () {
                    navigate('/bill-navigator-iframe');
                } }, getLocalizedString('SWITCH_KIT_SUCCESS_BUTTON'))) : (
            // This uses `shouldShowReopenButton` internally to determine if the button should be shown
            React.createElement(ReopenPinwheelButton, null)),
            React.createElement(Button, { eventId: "Success-exit", dataTestId: "button", onClick: exit, "aria-label": buttonLabel, variant: shouldShowReopenButton || isSwitchKit ? 'outline' : 'solid' }, buttonLabel)));
    }, [
        buttonLabel,
        exit,
        shouldShowReopenButton,
        linkSolution,
        navigate,
        getLocalizedString,
    ]);
    return (React.createElement(ScreenContainer, { "data-testid": "success" },
        React.createElement(ContentFrame, null,
            React.createElement(TemplateContinue, { Image: SuccessAnimation, title: title, subtitle: subtitle, actions: actions }))));
};
export default Success;
